import { call, put, takeEvery } from "redux-saga/effects";
import { phongUuTienNhomApi } from "../../../api/category/phongUuTienNhomApi";
import { IPhongUuTienNhom } from "../../../model/respone/category/IPhongUuTienNhom";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  ePhongUuTienNhomActionIds,
  IPhongUuTienNhomActionTypes,
} from "../../action-types/category/IPhongUuTienNhomActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.phongUuTienNhom;

export function* phongUuTienNhomSaga(): any {
  yield takeEvery(ePhongUuTienNhomActionIds.LOAD_START, loadWorker);
  yield takeEvery(ePhongUuTienNhomActionIds.SAVE_START, saveWorker);
  yield takeEvery(ePhongUuTienNhomActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(phongUuTienNhomApi.SelectAll);
  if (res.is_success) yield put(mainAction.LOAD_SUCCESS(res.data));
  else yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
}
function* saveWorker(action: IPhongUuTienNhomActionTypes): any {
  const payload = action.payload as IPhongUuTienNhom;
  const res: IBaseRespone = payload.id > 0
    ? yield call(phongUuTienNhomApi.Update, payload)
    : yield call(phongUuTienNhomApi.Insert, payload);
  if (res.is_success) yield put(mainAction.SAVE_SUCCESS(res.data));
  else yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
}
function* deleteWorker(action: IPhongUuTienNhomActionTypes): any {
  const res: IBaseRespone = yield call(phongUuTienNhomApi.Delete, action.payload as number);
  if (res.is_success) yield put(mainAction.DELETE_SUCCESS(res.data));
  else yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
}
